export default __webpack_public_path__ + "static/media/yabe_thumbnail.6a31462e.png";